module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.toolbarLoading),
      expression: "toolbarLoading"
    }],
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "シリーズ名（部分一致）"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getSeries
    }
  }, [_vm._v("検索")]), _vm._v(" "), (_vm.adminRole) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportCsv
    }
  }, [_vm._v("CSV出力")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新規追加")])], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 30,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.series,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "シリーズ名",
      "width": "300",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "更新日時",
      "width": "210",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm._f("formatDate")(scope.row.updatedAt)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("編集")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("削除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("一括削除")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "編集",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.closeEditForm
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "ID",
      "prop": "id"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.id),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "id", $$v)
      },
      expression: "editForm.id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "シリーズ名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "親シリーズ"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "選択して下さい",
      "value-key": "id"
    },
    model: {
      value: (_vm.editForm.parent),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "parent", $$v)
      },
      expression: "editForm.parent"
    }
  }, [_c('el-option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.allSeries), function(item) {
    return (item.id !== _vm.editForm.id) ? _c('el-option', {
      key: item.id,
      attrs: {
        "value": item,
        "label": item.name
      }
    }) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "作成日時"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "作成日時",
      "format": "yyyy/MM/dd HH:mm",
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.createdAt),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "createdAt", $$v)
      },
      expression: "editForm.createdAt"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "更新日時"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "更新日時",
      "format": "yyyy/MM/dd HH:mm",
      "disabled": ""
    },
    model: {
      value: (_vm.editForm.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "updatedAt", $$v)
      },
      expression: "editForm.updatedAt"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeEditForm($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("登録")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新規追加",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.closeAddForm
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "シリーズ名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "親シリーズ"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "選択して下さい",
      "value-key": "id"
    },
    model: {
      value: (_vm.addForm.parent),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "parent", $$v)
      },
      expression: "addForm.parent"
    }
  }, [_c('el-option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.allSeries), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item,
        "label": item.name
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeAddForm($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("登録")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d377ae26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contents/Series.vue
// module id = 1148
// module chunks = 1